<template>
    <td-dialog
        :title="$t(title)"
        :before-close="uploadDialogClose"
        :visible.sync="dialogUploadInfoVisible"
        width="400px"
        height="240px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form>
            <td-upload
                actionUrl="/templateManage/importModelFile"
                :autoUpload="true"
                :hasManual="true"
                :on-success="handSuccess"
                :on-error="handSuccess"
                message="pgMessage.UPLOAD_WORKFLOW_FILE"
                :multiple="false"
                :showFileList="true"
                accept=".wfl"
                limitSize="5"
            >
            </td-upload>
        </el-form>
        <span slot="footer" style="text-align:left">
            <td-button @click="cancel">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
export default {
    props: ['title', 'dialogUploadInfoVisible', 'isAddData'],
    // 定义变量
    data() {
        return {};
    },
    // 定义并实现方法体
    methods: {
        cancel() {
            this.$emit('uploadDialogClose');
        },
        // 关闭窗口之前需要调用的方法
        uploadDialogClose() {
            this.$emit('uploadDialogClose');
            this.dialogUploadInfoVisible = false;
        },
        // 文件上传成功后，逻辑处理
        handSuccess(response, file, fileList) {
            if (response === null || response.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ type: 'error', showClose: true, message: response.statusMessage });
                this.$log.error('workFlowAuthor/syncUserAndRoleInfo', response.message);
            } else {
                this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.UPLOADSUCESSE') });
                this.cancel();
            }
        }
    }
};
</script>
